var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakyonDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 20,
    viewBox: "0 0 69 20",
    fill: 0,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    },
    clipPath: "url(#clip0_1341_126117)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29724 0.00390625H0V2.26801H6.29724V0.00390625Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.618 6.10478C19.9171 4.92923 18.5367 4.24219 16.8209 4.24219C13.4751 4.24219 11.1387 6.6446 11.1387 10.0843C11.1387 13.5239 13.5375 16.1472 16.8432 16.1472C18.4866 16.1472 19.7823 15.5237 20.618 14.3403V15.817H22.834V4.57232H20.618V6.10478ZM16.9089 13.8853C14.9814 13.8853 13.3536 12.1855 13.3536 10.1724C13.3536 8.03429 14.8488 6.48176 16.9089 6.48176C18.969 6.48176 20.5299 8.17148 20.5299 10.1724C20.5299 12.1733 18.8721 13.8853 16.9089 13.8853Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4548 4.57172H31.7474L27.6752 9.36538V0H25.4602V15.8164H27.6752V11.2547L32.1262 15.8164H35.2247L29.8266 10.1874L34.4548 4.57172Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7406 4.57422L40.6087 12.1975L37.4768 4.57422H34.7861L39.313 14.7315L36.9276 20.0025H39.4534L46.4213 4.57422H43.7406Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3757 4.24219C48.1023 4.24219 45.5386 6.80855 45.5386 10.0843C45.5386 13.36 48.1023 16.1472 51.3757 16.1472C54.6491 16.1472 57.2116 13.4838 57.2116 10.0843C57.2116 6.68475 54.648 4.24219 51.3757 4.24219ZM51.3757 13.9299C49.3457 13.9299 47.7546 12.2413 47.7546 10.0854C47.7546 7.92945 49.3111 6.46057 51.3757 6.46057C53.4402 6.46057 54.9967 8.01868 54.9967 10.0854C54.9967 12.277 53.4402 13.9299 51.3757 13.9299Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3517 4.24219C62.7139 4.24219 61.4537 4.79316 60.7529 5.80364V4.57232H58.5369V15.817H60.7529V9.99615C60.7529 6.91897 62.774 6.45945 63.9773 6.45945C65.4357 6.45945 66.785 6.86878 66.785 9.84223V15.817H69.0011V9.33587C69.0011 6.05124 67.3499 4.24219 64.3528 4.24219H64.3517Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9946 2.26411V0H11.256C8.83385 0 6.86401 1.97189 6.86401 4.39661V15.8276H9.12576V4.39661C9.12576 3.22106 10.0806 2.26411 11.256 2.26411H15.9946Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1341_126117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 20,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakyonDark);
export default __webpack_public_path__ + "static/media/TakyonDark.16d98aced234036ebdad31b93dbd51e6.svg";
export { ForwardRef as ReactComponent };